export const MAP_RULE_PREFIX = 'map';
export var Map;
(function (Map) {
    Map["View"] = "map:view";
    Map["AllHabitats"] = "map:allHabitats";
})(Map || (Map = {}));
